import { ThemePalette } from '../../model/palette/palette.model';

/**
 * All 21 Codigrate theme palettes: 24 curated, theme-named colors each
 * (info/success/warning/error always the last colors).
 * GENERATED from the palette section of base-themes/<cat>/<key>-theme/<key>.source.json
 * (the master source) - regenerate instead of editing hexes or names by hand.
 * Every theme - free and premium alike - ships its palette platforms
 * (MacOS .clr under assets/palettes/, built by
 * base-themes/generators/macos-palette.js, with the color picker screenshot
 * captured in the theme's own light/dark appearance).
 */
export const THEME_PALETTES: ThemePalette[] = [
  {
    key: 'aurora-borealis',
    name: 'Aurora Borealis',
    category: 'nature',
    appearance: 'Dark',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        file: './assets/palettes/aurora-borealis/Codigrate Aurora Borealis.tokens.json',
        fileName: 'Codigrate Aurora Borealis.tokens.json',
        screenshot: {
          src: './assets/palettes/aurora-borealis/figma-palette-screenshot-1.webp',
          description: 'Aurora Borealis palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        file: './assets/palettes/aurora-borealis/Codigrate Aurora Borealis.xml',
        fileName: 'Codigrate Aurora Borealis.xml',
        screenshot: {
          src: './assets/palettes/aurora-borealis/coreldraw-palette-screenshot-1.webp',
          description: 'Aurora Borealis palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        file: './assets/palettes/aurora-borealis/Codigrate Aurora Borealis.clr',
        fileName: 'Codigrate Aurora Borealis.clr',
        screenshot: {
          src: './assets/palettes/aurora-borealis/macos-palette-screenshot-1.webp',
          description: 'Aurora Borealis palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Polar Night', hex: '#142B37' },
      { name: 'Arctic Depth', hex: '#123243' },
      { name: 'Glacial Shelf', hex: '#1A3746' },
      { name: 'Deep Fjord', hex: '#1E3F53' },
      { name: 'Boreal Pine', hex: '#043A33' },
      { name: 'Emerald Aurora', hex: '#049682' },
      { name: 'Teal Glow', hex: '#05C0A6' },
      { name: 'Northern Green', hex: '#73D379' },
      { name: 'Moonlit Frost', hex: '#B0B9BE' },
      { name: 'Winter Haze', hex: '#85A2B3' },
      { name: 'Arctic Cyan', hex: '#7ACEF5' },
      { name: 'Polar Blue', hex: '#549EFF' },
      { name: 'Lavender Light', hex: '#BAA5FF' },
      { name: 'Violet Curtain', hex: '#A55CC8' },
      { name: 'Twilight Rose', hex: '#BB719B' },
      { name: 'Pink Aurora', hex: '#D193BB' },
      { name: 'Glacier Blue', hex: '#5AA6DA' },
      { name: 'Deep Glacier', hex: '#3EA0E3' },
      { name: 'Lichen Green', hex: '#5BC093' },
      { name: 'Deep Lichen', hex: '#3FC88B' },
      { name: 'Midnight Sun', hex: '#CBA45E' },
      { name: 'Deep Midnight Sun', hex: '#D49A3C' },
      { name: 'Red Aurora', hex: '#D0636C' },
      { name: 'Deep Red Aurora', hex: '#D74E5B' },
    ],
  },
  {
    key: 'autumn',
    name: 'Autumn',
    category: 'nature',
    appearance: 'Light',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        file: './assets/palettes/autumn/Codigrate Autumn.tokens.json',
        fileName: 'Codigrate Autumn.tokens.json',
        screenshot: {
          src: './assets/palettes/autumn/figma-palette-screenshot-1.webp',
          description: 'Autumn palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        file: './assets/palettes/autumn/Codigrate Autumn.xml',
        fileName: 'Codigrate Autumn.xml',
        screenshot: {
          src: './assets/palettes/autumn/coreldraw-palette-screenshot-1.webp',
          description: 'Autumn palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        file: './assets/palettes/autumn/Codigrate Autumn.clr',
        fileName: 'Codigrate Autumn.clr',
        screenshot: {
          src: './assets/palettes/autumn/macos-palette-screenshot-1.webp',
          description: 'Autumn palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Parchment', hex: '#FCFBFA' },
      { name: 'Pale Birch', hex: '#F8F4F1' },
      { name: 'Sandstone', hex: '#EFE6E0' },
      { name: 'Apricot Haze', hex: '#F4D3BD' },
      { name: 'Late Meadow', hex: '#E5F4CD' },
      { name: 'Olive Grove', hex: '#A9C779' },
      { name: 'Harvest Gold', hex: '#A87F25' },
      { name: 'Golden Leaf', hex: '#DEA51D' },
      { name: 'Copper Leaf', hex: '#B0633A' },
      { name: 'Maple Rust', hex: '#BE553E' },
      { name: 'Acorn Brown', hex: '#773918' },
      { name: 'Mocha', hex: '#82614C' },
      { name: 'Dark Walnut', hex: '#2E1B0F' },
      { name: 'Pine Shadow', hex: '#1B591E' },
      { name: 'Evergreen', hex: '#0E8113' },
      { name: 'Mallard Teal', hex: '#006E83' },
      { name: 'October Sky', hex: '#397FB7' },
      { name: 'Deep October', hex: '#2876B4' },
      { name: 'Fern Green', hex: '#30A25E' },
      { name: 'Deep Fern', hex: '#219D53' },
      { name: 'Amber Harvest', hex: '#D49A2A' },
      { name: 'Deep Harvest', hex: '#D0921A' },
      { name: 'Cranberry', hex: '#C8504A' },
      { name: 'Deep Cranberry', hex: '#D0352D' },
    ],
  },
  {
    key: 'etna',
    name: 'Etna',
    category: 'nature',
    appearance: 'Dark',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        screenshot: {
          src: './assets/palettes/etna/figma-palette-screenshot-1.webp',
          description: 'Etna palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        screenshot: {
          src: './assets/palettes/etna/coreldraw-palette-screenshot-1.webp',
          description: 'Etna palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        screenshot: {
          src: './assets/palettes/etna/macos-palette-screenshot-1.webp',
          description: 'Etna palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Obsidian', hex: '#080808' },
      { name: 'Volcanic Ash', hex: '#121111' },
      { name: 'Basalt Grey', hex: '#1E1D1D' },
      { name: 'Ash Stone', hex: '#222121' },
      { name: 'Slag Grey', hex: '#363434' },
      { name: 'Smoke Grey', hex: '#444242' },
      { name: 'Graphite', hex: '#4C4A4A' },
      { name: 'Pumice', hex: '#807C7C' },
      { name: 'Smoke Veil', hex: '#B3AEAE' },
      { name: 'White Ash', hex: '#D5CFCF' },
      { name: 'Sulfur Haze', hex: '#E2BF79' },
      { name: 'Molten Glow', hex: '#E67748' },
      { name: 'Burnt Sienna', hex: '#C66439' },
      { name: 'Ember Coral', hex: '#F1735F' },
      { name: 'Lava Rose', hex: '#D74C57' },
      { name: 'Ember Bed', hex: '#3F171A' },
      { name: 'Ionian Blue', hex: '#6A96C8' },
      { name: 'Deep Ionian', hex: '#4F8BCF' },
      { name: 'Vineyard Green', hex: '#85B66F' },
      { name: 'Deep Vineyard', hex: '#75BC54' },
      { name: 'Sulfur Gold', hex: '#CDA337' },
      { name: 'Deep Sulfur', hex: '#CD9D23' },
      { name: 'Eruption Red', hex: '#CF383C' },
      { name: 'Deep Eruption', hex: '#E23A42' },
    ],
  },
  {
    key: 'fuji',
    name: 'Fuji',
    category: 'nature',
    appearance: 'Light',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        screenshot: {
          src: './assets/palettes/fuji/figma-palette-screenshot-1.webp',
          description: 'Fuji palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        screenshot: {
          src: './assets/palettes/fuji/coreldraw-palette-screenshot-1.webp',
          description: 'Fuji palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        screenshot: {
          src: './assets/palettes/fuji/macos-palette-screenshot-1.webp',
          description: 'Fuji palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Snow White', hex: '#FFFCFB' },
      { name: 'Petal Mist', hex: '#FBEAE3' },
      { name: 'Petal Peach', hex: '#FBD5C7' },
      { name: 'Dawn Peach', hex: '#F5D9D0' },
      { name: 'Coral Sand', hex: '#E0C4BB' },
      { name: 'Ember Coral', hex: '#E39177' },
      { name: 'Coral Flame', hex: '#F4704D' },
      { name: 'Torii Orange', hex: '#DC5B26' },
      { name: 'Terracotta', hex: '#D37154' },
      { name: 'Peach Sand', hex: '#C9A08C' },
      { name: 'Clay', hex: '#AE8574' },
      { name: 'Blossom Pink', hex: '#ED84B0' },
      { name: 'Sakura Rose', hex: '#DD747A' },
      { name: 'Mauve Plum', hex: '#BF8AB3' },
      { name: 'Dusty Rose', hex: '#B76C88' },
      { name: 'Rose Taupe', hex: '#8A6A61' },
      { name: 'Fuji Teal', hex: '#39A1A5' },
      { name: 'Lake Teal', hex: '#45888E' },
      { name: 'Slate Blue', hex: '#5F7D9F' },
      { name: 'Sepia Ink', hex: '#45302B' },
      { name: 'Fuji Blue', hex: '#2E7DC4' },
      { name: 'Pine Green', hex: '#3E8E5E' },
      { name: 'Shrine Gold', hex: '#D69A2E' },
      { name: 'Maple Red', hex: '#C8453A' },
    ],
  },
  {
    key: 'everest',
    name: 'Everest',
    category: 'nature',
    appearance: 'Light',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        file: './assets/palettes/everest/Codigrate Everest.tokens.json',
        fileName: 'Codigrate Everest.tokens.json',
        screenshot: {
          src: './assets/palettes/everest/figma-palette-screenshot-1.webp',
          description: 'Everest palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        file: './assets/palettes/everest/Codigrate Everest.xml',
        fileName: 'Codigrate Everest.xml',
        screenshot: {
          src: './assets/palettes/everest/coreldraw-palette-screenshot-1.webp',
          description: 'Everest palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        file: './assets/palettes/everest/Codigrate Everest.clr',
        fileName: 'Codigrate Everest.clr',
        screenshot: {
          src: './assets/palettes/everest/macos-palette-screenshot-1.webp',
          description: 'Everest palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Summit Snow', hex: '#FDFEFF' },
      { name: 'Morning Mist', hex: '#E4ECEF' },
      { name: 'Ice Melt', hex: '#B6D8E5' },
      { name: 'Dawn Blush', hex: '#F6D4C8' },
      { name: 'Alpenglow', hex: '#EC9C81' },
      { name: 'Sunrise Flame', hex: '#ED7E5A' },
      { name: 'Granite Red', hex: '#8F4446' },
      { name: 'Rhododendron', hex: '#8C4069' },
      { name: 'Mountain Iris', hex: '#83529B' },
      { name: 'Mountain Blue', hex: '#1A6D9F' },
      { name: 'Deep Crevasse', hex: '#246A89' },
      { name: 'Blue Ice', hex: '#005E79' },
      { name: 'Storm Grey', hex: '#567B8A' },
      { name: 'Pine Ridge', hex: '#2E674F' },
      { name: 'Juniper', hex: '#007A47' },
      { name: 'Midnight Ridge', hex: '#0E3448' },
      { name: 'Clear Sky', hex: '#397FB7' },
      { name: 'Deep Sky', hex: '#2876B4' },
      { name: 'Moss Green', hex: '#30A25E' },
      { name: 'Deep Moss', hex: '#219D53' },
      { name: 'Golden Hour', hex: '#C8963E' },
      { name: 'Deep Gold', hex: '#C98F28' },
      { name: 'Expedition Red', hex: '#C8534E' },
      { name: 'Deep Expedition', hex: '#D13731' },
    ],
  },
  {
    key: 'ocean',
    name: 'Ocean',
    category: 'nature',
    appearance: 'Dark',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        screenshot: {
          src: './assets/palettes/ocean/figma-palette-screenshot-1.webp',
          description: 'Ocean palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        screenshot: {
          src: './assets/palettes/ocean/coreldraw-palette-screenshot-1.webp',
          description: 'Ocean palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        screenshot: {
          src: './assets/palettes/ocean/macos-palette-screenshot-1.webp',
          description: 'Ocean palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Ocean Floor', hex: '#0B2225' },
      { name: 'Deep Water', hex: '#102B2E' },
      { name: 'Dark Current', hex: '#18383C' },
      { name: 'Deep Reef', hex: '#1C4247' },
      { name: 'Trench Blue', hex: '#14364D' },
      { name: 'Slate Depth', hex: '#425064' },
      { name: 'Open Water', hex: '#33698E' },
      { name: 'Tropic Cyan', hex: '#3FB4D8' },
      { name: 'Lagoon Teal', hex: '#0BA0A5' },
      { name: 'Sea Glass', hex: '#5AB590' },
      { name: 'Sea Salt', hex: '#AFBABD' },
      { name: 'Pale Sandbar', hex: '#EAC089' },
      { name: 'Coral Sand', hex: '#DC9577' },
      { name: 'Coral Blush', hex: '#DC7783' },
      { name: 'Anemone Pink', hex: '#EE8EBF' },
      { name: 'Urchin Violet', hex: '#B88BDA' },
      { name: 'Horizon Blue', hex: '#4A9BD8' },
      { name: 'Deep Horizon', hex: '#2C94E2' },
      { name: 'Seagrass', hex: '#52BA88' },
      { name: 'Deep Seagrass', hex: '#39BF7E' },
      { name: 'Sandbar Gold', hex: '#D6A44E' },
      { name: 'Deep Sandbar', hex: '#DF9F30' },
      { name: 'Coral Red', hex: '#C74D5C' },
      { name: 'Deep Coral', hex: '#D02F43' },
    ],
  },
  {
    key: 'reynisfjara',
    name: 'Reynisfjara',
    category: 'nature',
    appearance: 'Dark',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        screenshot: {
          src: './assets/palettes/reynisfjara/figma-palette-screenshot-1.webp',
          description: 'Reynisfjara palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        screenshot: {
          src: './assets/palettes/reynisfjara/coreldraw-palette-screenshot-1.webp',
          description: 'Reynisfjara palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        screenshot: {
          src: './assets/palettes/reynisfjara/macos-palette-screenshot-1.webp',
          description: 'Reynisfjara palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Sea Cave', hex: '#060709' },
      { name: 'Black Sand', hex: '#151A20' },
      { name: 'Basalt Column', hex: '#20262C' },
      { name: 'Dark Shore', hex: '#2A3138' },
      { name: 'Wet Sand', hex: '#3E3B37' },
      { name: 'Weathered Basalt', hex: '#4F545A' },
      { name: 'Gull Grey', hex: '#7D848D' },
      { name: 'Overcast', hex: '#8B95A2' },
      { name: 'North Wave', hex: '#9FA9B9' },
      { name: 'Sea Foam', hex: '#AEB6C0' },
      { name: 'Sea Spray', hex: '#BEC3C8' },
      { name: 'Bleached Sand', hex: '#C3B9AD' },
      { name: 'Driftwood', hex: '#B1AC9B' },
      { name: 'Pale Driftwood', hex: '#C5A98F' },
      { name: 'Washed Timber', hex: '#AC8563' },
      { name: 'Beach Pebble', hex: '#8E8276' },
      { name: 'Cold Horizon', hex: '#6C98B7' },
      { name: 'Deep Horizon', hex: '#5490BB' },
      { name: 'Moss Rock', hex: '#6EAB82' },
      { name: 'Deep Moss', hex: '#56AF73' },
      { name: 'Winter Sun', hex: '#BA9D5F' },
      { name: 'Deep Winter Sun', hex: '#BF9846' },
      { name: 'Iron Red', hex: '#BD6F66' },
      { name: 'Deep Iron', hex: '#C2594D' },
    ],
  },
  {
    key: 'roraima',
    name: 'Roraima',
    category: 'nature',
    appearance: 'Dark',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        file: './assets/palettes/roraima/Codigrate Roraima.tokens.json',
        fileName: 'Codigrate Roraima.tokens.json',
        screenshot: {
          src: './assets/palettes/roraima/figma-palette-screenshot-1.webp',
          description: 'Roraima palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        file: './assets/palettes/roraima/Codigrate Roraima.xml',
        fileName: 'Codigrate Roraima.xml',
        screenshot: {
          src: './assets/palettes/roraima/coreldraw-palette-screenshot-1.webp',
          description: 'Roraima palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        file: './assets/palettes/roraima/Codigrate Roraima.clr',
        fileName: 'Codigrate Roraima.clr',
        screenshot: {
          src: './assets/palettes/roraima/macos-palette-screenshot-1.webp',
          description: 'Roraima palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Cave Floor', hex: '#171415' },
      { name: 'Tepui Night', hex: '#1E1A1B' },
      { name: 'Canyon Shadow', hex: '#322628' },
      { name: 'Earthen Ledge', hex: '#523C2D' },
      { name: 'Terracotta Shade', hex: '#582F29' },
      { name: 'Ochre Cliff', hex: '#6F4E35' },
      { name: 'Misty Rose', hex: '#AD8A8A' },
      { name: 'Cloud Veil', hex: '#CEC1C1' },
      { name: 'Amber Sand', hex: '#D69568' },
      { name: 'Coral Canyon', hex: '#D17458' },
      { name: 'Sunset Mesa', hex: '#CC654E' },
      { name: 'Pink Quartz', hex: '#ED8B8B' },
      { name: 'Dry Grass', hex: '#DDBE6D' },
      { name: 'Savanna Gold', hex: '#D1BA46' },
      { name: 'Twilight Violet', hex: '#7E6AA3' },
      { name: 'Orchid Mist', hex: '#8F78B7' },
      { name: 'River Blue', hex: '#5292C7' },
      { name: 'Deep River', hex: '#358AD0' },
      { name: 'Valley Green', hex: '#4CC27B' },
      { name: 'Deep Valley', hex: '#32C86E' },
      { name: 'Sun Ochre', hex: '#CDA644' },
      { name: 'Deep Ochre', hex: '#D5A427' },
      { name: 'Jasper Red', hex: '#CE4A44' },
      { name: 'Deep Jasper', hex: '#D72E27' },
    ],
  },
  {
    key: 'sakura',
    name: 'Sakura',
    category: 'nature',
    appearance: 'Light',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        file: './assets/palettes/sakura/Codigrate Sakura.tokens.json',
        fileName: 'Codigrate Sakura.tokens.json',
        screenshot: {
          src: './assets/palettes/sakura/figma-palette-screenshot-1.webp',
          description: 'Sakura palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        file: './assets/palettes/sakura/Codigrate Sakura.xml',
        fileName: 'Codigrate Sakura.xml',
        screenshot: {
          src: './assets/palettes/sakura/coreldraw-palette-screenshot-1.webp',
          description: 'Sakura palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        file: './assets/palettes/sakura/Codigrate Sakura.clr',
        fileName: 'Codigrate Sakura.clr',
        screenshot: {
          src: './assets/palettes/sakura/macos-palette-screenshot-1.webp',
          description: 'Sakura palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Blossom White', hex: '#FEFCFC' },
      { name: 'Petal Veil', hex: '#F8DBE6' },
      { name: 'Wisteria Mist', hex: '#DFD7EF' },
      { name: 'Full Bloom', hex: '#FFC9DC' },
      { name: 'Blush Pink', hex: '#EFA5BF' },
      { name: 'Rose Garden', hex: '#CB6B91' },
      { name: 'Deep Sakura', hex: '#B54B66' },
      { name: 'Plum Wine', hex: '#98556C' },
      { name: 'Mauve Shadow', hex: '#94667D' },
      { name: 'Morning Fog', hex: '#687788' },
      { name: 'River Stone', hex: '#607FA9' },
      { name: 'Spring Rain', hex: '#69A2BD' },
      { name: 'Tea Leaf', hex: '#618C71' },
      { name: 'New Stem', hex: '#AEC09B' },
      { name: 'Spring Leaf', hex: '#DBEACB' },
      { name: 'Dark Cherry', hex: '#3D0013' },
      { name: 'Clear Sky', hex: '#397FB7' },
      { name: 'Deep Sky', hex: '#2876B4' },
      { name: 'Leaf Green', hex: '#30A25E' },
      { name: 'Deep Leaf', hex: '#219D53' },
      { name: 'Pollen Gold', hex: '#BC9C5C' },
      { name: 'Deep Pollen', hex: '#C49840' },
      { name: 'Camellia Red', hex: '#BE5C55' },
      { name: 'Deep Camellia', hex: '#C64238' },
    ],
  },
  {
    key: 'salda',
    name: 'Salda',
    category: 'nature',
    appearance: 'Light',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        screenshot: {
          src: './assets/palettes/salda/figma-palette-screenshot-1.webp',
          description: 'Salda palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        screenshot: {
          src: './assets/palettes/salda/coreldraw-palette-screenshot-1.webp',
          description: 'Salda palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        screenshot: {
          src: './assets/palettes/salda/macos-palette-screenshot-1.webp',
          description: 'Salda palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Shell White', hex: '#FFFFFF' },
      { name: 'White Sand', hex: '#FDFCFA' },
      { name: 'Warm Shore', hex: '#FDF6E7' },
      { name: 'Sandbank', hex: '#ECE1C9' },
      { name: 'Shallow Turquoise', hex: '#B8E4EC' },
      { name: 'Soft Lagoon', hex: '#68B0BC' },
      { name: 'Bright Lagoon', hex: '#1397AE' },
      { name: 'Lakeshore Blue', hex: '#44849F' },
      { name: 'Shaded Lagoon', hex: '#277878' },
      { name: 'Reed Green', hex: '#0F9363' },
      { name: 'Shore Shadow', hex: '#685C43' },
      { name: 'Cedar Bark', hex: '#715827' },
      { name: 'Clay Bank', hex: '#8F6055' },
      { name: 'Driftsand', hex: '#A59379' },
      { name: 'Dune Edge', hex: '#B9A373' },
      { name: 'Dark Cedar', hex: '#312408' },
      { name: 'Lake Blue', hex: '#3C8CCE' },
      { name: 'Deep Lake', hex: '#2483D2' },
      { name: 'Spring Green', hex: '#3ACA68' },
      { name: 'Deep Spring', hex: '#26CA5A' },
      { name: 'Sun Wheat', hex: '#D5BA63' },
      { name: 'Deep Wheat', hex: '#DDB947' },
      { name: 'Terra Rosa', hex: '#D05B52' },
      { name: 'Deep Terra', hex: '#D94035' },
    ],
  },
  {
    key: 'sequoia',
    name: 'Sequoia',
    category: 'nature',
    appearance: 'Dark',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        file: './assets/palettes/sequoia/Codigrate Sequoia.tokens.json',
        fileName: 'Codigrate Sequoia.tokens.json',
        screenshot: {
          src: './assets/palettes/sequoia/figma-palette-screenshot-1.webp',
          description: 'Sequoia palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        file: './assets/palettes/sequoia/Codigrate Sequoia.xml',
        fileName: 'Codigrate Sequoia.xml',
        screenshot: {
          src: './assets/palettes/sequoia/coreldraw-palette-screenshot-1.webp',
          description: 'Sequoia palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        file: './assets/palettes/sequoia/Codigrate Sequoia.clr',
        fileName: 'Codigrate Sequoia.clr',
        screenshot: {
          src: './assets/palettes/sequoia/macos-palette-screenshot-1.webp',
          description: 'Sequoia palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Deep Grove', hex: '#0E0E0E' },
      { name: 'Forest Floor', hex: '#20231C' },
      { name: 'Evergreen Shade', hex: '#32382C' },
      { name: 'Fern Shade', hex: '#405133' },
      { name: 'Driftwood', hex: '#6C625A' },
      { name: 'Faded Rosewood', hex: '#986969' },
      { name: 'Redwood Clay', hex: '#A86255' },
      { name: 'Warm Timber', hex: '#A67B5B' },
      { name: 'Golden Bark', hex: '#A68F59' },
      { name: 'Olive Canopy', hex: '#788B40' },
      { name: 'Meadow Green', hex: '#6E9F56' },
      { name: 'Jade Moss', hex: '#369772' },
      { name: 'Lichen Grey', hex: '#849184' },
      { name: 'Morning Light', hex: '#BABEBA' },
      { name: 'Cedar Heart', hex: '#6D4130' },
      { name: 'Fresh Growth', hex: '#73A621' },
      { name: 'Creek Blue', hex: '#4A93C0' },
      { name: 'Deep Creek', hex: '#328CC4' },
      { name: 'Sapling Green', hex: '#5CB36A' },
      { name: 'Deep Sapling', hex: '#42B955' },
      { name: 'Sap Gold', hex: '#C39A45' },
      { name: 'Deep Sap', hex: '#C6942E' },
      { name: 'Wildfire Red', hex: '#C2564B' },
      { name: 'Deep Wildfire', hex: '#C73F31' },
    ],
  },
  {
    key: 'spring',
    name: 'Spring',
    category: 'nature',
    appearance: 'Light',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        screenshot: {
          src: './assets/palettes/spring/figma-palette-screenshot-1.webp',
          description: 'Spring palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        screenshot: {
          src: './assets/palettes/spring/coreldraw-palette-screenshot-1.webp',
          description: 'Spring palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        screenshot: {
          src: './assets/palettes/spring/macos-palette-screenshot-1.webp',
          description: 'Spring palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Daisy White', hex: '#FFFFFF' },
      { name: 'Mint Air', hex: '#F4FFF1' },
      { name: 'New Grass', hex: '#C8EAB9' },
      { name: 'Garden Hedge', hex: '#7BA566' },
      { name: 'Clover Green', hex: '#559569' },
      { name: 'Fern Frond', hex: '#3C8F63' },
      { name: 'Deep Meadow', hex: '#356220' },
      { name: 'Shaded Leaf', hex: '#49613F' },
      { name: 'Dark Moss', hex: '#122C07' },
      { name: 'Dusty Sage', hex: '#8A9E80' },
      { name: 'Robin Egg', hex: '#5E9AAE' },
      { name: 'Cornflower', hex: '#527FB6' },
      { name: 'Crocus Violet', hex: '#8C68AC' },
      { name: 'Lilac Bloom', hex: '#D5B3F4' },
      { name: 'Rosebud', hex: '#DC8395' },
      { name: 'Foxglove', hex: '#BA6173' },
      { name: 'Clear Sky', hex: '#397FB7' },
      { name: 'Deep Sky', hex: '#2876B4' },
      { name: 'Sprout Green', hex: '#73C71A' },
      { name: 'Deep Sprout', hex: '#69C00C' },
      { name: 'Dandelion', hex: '#D1D72C' },
      { name: 'Deep Dandelion', hex: '#CFD619' },
      { name: 'Tulip Red', hex: '#CE5563' },
      { name: 'Deep Tulip', hex: '#D7384A' },
    ],
  },
  {
    key: 'istanbul',
    name: 'Istanbul',
    category: 'cities',
    appearance: 'Light',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        file: './assets/palettes/istanbul/Codigrate Istanbul.tokens.json',
        fileName: 'Codigrate Istanbul.tokens.json',
        screenshot: {
          src: './assets/palettes/istanbul/figma-palette-screenshot-1.webp',
          description: 'Istanbul palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        file: './assets/palettes/istanbul/Codigrate Istanbul.xml',
        fileName: 'Codigrate Istanbul.xml',
        screenshot: {
          src: './assets/palettes/istanbul/coreldraw-palette-screenshot-1.webp',
          description: 'Istanbul palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        file: './assets/palettes/istanbul/Codigrate Istanbul.clr',
        fileName: 'Codigrate Istanbul.clr',
        screenshot: {
          src: './assets/palettes/istanbul/macos-palette-screenshot-1.webp',
          description: 'Istanbul palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Marble White', hex: '#FAFDFD' },
      { name: 'Bosphorus Mist', hex: '#DBF0F1' },
      { name: 'Sea Glass', hex: '#A3DDE5' },
      { name: 'Turquoise Tile', hex: '#91D1DA' },
      { name: 'Iznik Turquoise', hex: '#12ACC1' },
      { name: 'Bosphorus Teal', hex: '#1190A1' },
      { name: 'Deep Bosphorus', hex: '#087E8E' },
      { name: 'Marmara Blue', hex: '#0887B5' },
      { name: 'Midnight Strait', hex: '#083A41' },
      { name: 'Ottoman Rose', hex: '#9C6E7C' },
      { name: 'Tulip Pink', hex: '#C16979' },
      { name: 'Rooftop Red', hex: '#B8514D' },
      { name: 'Copper Bazaar', hex: '#B87958' },
      { name: 'Golden Horn', hex: '#C0AF43' },
      { name: 'Old Parchment', hex: '#EFEAD0' },
      { name: 'Lilac Haze', hex: '#D5C5E1' },
      { name: 'Ferry Blue', hex: '#397FB7' },
      { name: 'Deep Ferry', hex: '#2876B4' },
      { name: 'Cypress Green', hex: '#30A25E' },
      { name: 'Deep Cypress', hex: '#219D53' },
      { name: 'Brass Lamp', hex: '#BDA051' },
      { name: 'Deep Brass', hex: '#C39D37' },
      { name: 'Kilim Red', hex: '#C15C53' },
      { name: 'Deep Kilim', hex: '#CA4236' },
    ],
  },
  {
    key: 'madrid',
    name: 'Madrid',
    category: 'cities',
    appearance: 'Light',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        screenshot: {
          src: './assets/palettes/madrid/figma-palette-screenshot-1.webp',
          description: 'Madrid palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        screenshot: {
          src: './assets/palettes/madrid/coreldraw-palette-screenshot-1.webp',
          description: 'Madrid palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        screenshot: {
          src: './assets/palettes/madrid/macos-palette-screenshot-1.webp',
          description: 'Madrid palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Linen White', hex: '#FFFFFF' },
      { name: 'Golden Morning', hex: '#FDF5DF' },
      { name: 'Rose Terrace', hex: '#F8D6CF' },
      { name: 'Sunlit Facade', hex: '#F8DFA3' },
      { name: 'Madrid Gold', hex: '#E8C25D' },
      { name: 'Saffron', hex: '#DCA225' },
      { name: 'Toledo Gold', hex: '#A57F02' },
      { name: 'Olive Bronze', hex: '#745606' },
      { name: 'Dark Umber', hex: '#372805' },
      { name: 'Spanish Red', hex: '#902926' },
      { name: 'Sangria', hex: '#B84440' },
      { name: 'Flamenco Red', hex: '#BD503F' },
      { name: 'Clay Rose', hex: '#D37969' },
      { name: 'Terracotta', hex: '#D79668' },
      { name: 'Azulejo Blue', hex: '#5A91A8' },
      { name: 'Andalusian Teal', hex: '#349590' },
      { name: 'Plaza Blue', hex: '#5692C3' },
      { name: 'Deep Plaza', hex: '#3887C8' },
      { name: 'Retiro Green', hex: '#40BB71' },
      { name: 'Deep Retiro', hex: '#2FB263' },
      { name: 'Amber Sun', hex: '#D8B564' },
      { name: 'Deep Amber', hex: '#DDAF46' },
      { name: 'Rioja', hex: '#CA6D68' },
      { name: 'Deep Rioja', hex: '#CE514B' },
    ],
  },
  {
    key: 'miami',
    name: 'Miami',
    category: 'cities',
    appearance: 'Dark',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        file: './assets/palettes/miami/Codigrate Miami.tokens.json',
        fileName: 'Codigrate Miami.tokens.json',
        screenshot: {
          src: './assets/palettes/miami/figma-palette-screenshot-1.webp',
          description: 'Miami palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        file: './assets/palettes/miami/Codigrate Miami.xml',
        fileName: 'Codigrate Miami.xml',
        screenshot: {
          src: './assets/palettes/miami/coreldraw-palette-screenshot-1.webp',
          description: 'Miami palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        file: './assets/palettes/miami/Codigrate Miami.clr',
        fileName: 'Codigrate Miami.clr',
        screenshot: {
          src: './assets/palettes/miami/macos-palette-screenshot-1.webp',
          description: 'Miami palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Midnight Vice', hex: '#33121D' },
      { name: 'Plum Night', hex: '#532033' },
      { name: 'Berry Crush', hex: '#722E47' },
      { name: 'Neon Raspberry', hex: '#99224D' },
      { name: 'Miami Pink', hex: '#FF5FA2' },
      { name: 'Flamingo', hex: '#FE788C' },
      { name: 'Sunset Coral', hex: '#FE8078' },
      { name: 'Coral Haze', hex: '#F2A4A0' },
      { name: 'Dusty Orchid', hex: '#CCA2B6' },
      { name: 'Pearl Pink', hex: '#D5C6CE' },
      { name: 'Art Deco Blue', hex: '#92B5E8' },
      { name: 'Tropical Teal', hex: '#059086' },
      { name: 'Electric Aqua', hex: '#00D1C1' },
      { name: 'Palm Green', hex: '#82D59F' },
      { name: 'Golden Sand', hex: '#F8D273' },
      { name: 'Deep Lagoon', hex: '#03534D' },
      { name: 'Bay Blue', hex: '#53A5DC' },
      { name: 'Deep Bay', hex: '#369FE5' },
      { name: 'Lime Twist', hex: '#6CC952' },
      { name: 'Deep Lime', hex: '#57D235' },
      { name: 'Amber Neon', hex: '#E6B250' },
      { name: 'Deep Amber', hex: '#F0AE32' },
      { name: 'Hot Coral', hex: '#EC5B54' },
      { name: 'Deep Coral', hex: '#F63F36' },
    ],
  },
  {
    key: 'paris',
    name: 'Paris',
    category: 'cities',
    appearance: 'Dark',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        file: './assets/palettes/paris/Codigrate Paris.tokens.json',
        fileName: 'Codigrate Paris.tokens.json',
        screenshot: {
          src: './assets/palettes/paris/figma-palette-screenshot-1.webp',
          description: 'Paris palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        file: './assets/palettes/paris/Codigrate Paris.xml',
        fileName: 'Codigrate Paris.xml',
        screenshot: {
          src: './assets/palettes/paris/coreldraw-palette-screenshot-1.webp',
          description: 'Paris palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        file: './assets/palettes/paris/Codigrate Paris.clr',
        fileName: 'Codigrate Paris.clr',
        screenshot: {
          src: './assets/palettes/paris/macos-palette-screenshot-1.webp',
          description: 'Paris palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Ink Noir', hex: '#100D0E' },
      { name: 'Parisian Night', hex: '#281D22' },
      { name: 'Cabaret Shadow', hex: '#4F303C' },
      { name: 'Wine Cellar', hex: '#532D33' },
      { name: 'Mauve Salon', hex: '#5D3F49' },
      { name: 'Rosewood', hex: '#6A3C4D' },
      { name: 'Bordeaux', hex: '#994753' },
      { name: 'Cherry Macaron', hex: '#DF7583' },
      { name: 'Montmartre Rose', hex: '#D584A3' },
      { name: 'Rose Smoke', hex: '#C79FAE' },
      { name: 'Peach Macaron', hex: '#F3B7A9' },
      { name: 'Ivory Lace', hex: '#E6D7DD' },
      { name: 'Twilight Blue', hex: '#87A1D3' },
      { name: 'Seine Blue', hex: '#5E7BB3' },
      { name: 'Cafe Lights', hex: '#FBBA77' },
      { name: 'Champagne Gold', hex: '#F1C970' },
      { name: 'French Blue', hex: '#5A8AC0' },
      { name: 'Deep French Blue', hex: '#3E7FC8' },
      { name: 'Tuileries Green', hex: '#5CA86C' },
      { name: 'Deep Tuileries', hex: '#46A95B' },
      { name: 'Eiffel Gold', hex: '#D5A24C' },
      { name: 'Deep Eiffel', hex: '#DE9D2E' },
      { name: 'Rouge', hex: '#D15A56' },
      { name: 'Deep Rouge', hex: '#DA3E39' },
    ],
  },
  {
    key: 'prague',
    name: 'Prague',
    category: 'cities',
    appearance: 'Dark',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        screenshot: {
          src: './assets/palettes/prague/figma-palette-screenshot-1.webp',
          description: 'Prague palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        screenshot: {
          src: './assets/palettes/prague/coreldraw-palette-screenshot-1.webp',
          description: 'Prague palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        screenshot: {
          src: './assets/palettes/prague/macos-palette-screenshot-1.webp',
          description: 'Prague palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Old Town Shadow', hex: '#070F17' },
      { name: 'Vltava Night', hex: '#0D1D2E' },
      { name: 'Castle Night', hex: '#123151' },
      { name: 'Bohemian Blue', hex: '#113E6B' },
      { name: 'Bridge Blue', hex: '#1E5FA0' },
      { name: 'Slate Blue', hex: '#3E6895' },
      { name: 'Stone Blue', hex: '#92A3B3' },
      { name: 'Moonstone', hex: '#BBC9D7' },
      { name: 'Pale Vltava', hex: '#89C5F8' },
      { name: 'Daylight Blue', hex: '#74ADF8' },
      { name: 'Candle Gold', hex: '#B0986C' },
      { name: 'Parchment Gold', hex: '#DCCF9D' },
      { name: 'Straw Gold', hex: '#E3CA77' },
      { name: 'Amber Lantern', hex: '#EFBA5A' },
      { name: 'Rooftop Copper', hex: '#DF865B' },
      { name: 'Brass Shadow', hex: '#544723' },
      { name: 'Vltava Blue', hex: '#4A93D8' },
      { name: 'Deep Vltava', hex: '#2C89E2' },
      { name: 'Verdigris', hex: '#4FBA80' },
      { name: 'Deep Verdigris', hex: '#37BD75' },
      { name: 'Lantern Gold', hex: '#D8A94A' },
      { name: 'Deep Lantern', hex: '#E2A52C' },
      { name: 'Cardinal Red', hex: '#D0605C' },
      { name: 'Deep Cardinal', hex: '#D8453F' },
    ],
  },
  {
    key: 'rio-de-janeiro',
    name: 'Rio de Janeiro',
    category: 'cities',
    appearance: 'Light',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        file: './assets/palettes/rio-de-janeiro/Codigrate Rio de Janeiro.tokens.json',
        fileName: 'Codigrate Rio de Janeiro.tokens.json',
        screenshot: {
          src: './assets/palettes/rio-de-janeiro/figma-palette-screenshot-1.webp',
          description: 'Rio de Janeiro palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        file: './assets/palettes/rio-de-janeiro/Codigrate Rio de Janeiro.xml',
        fileName: 'Codigrate Rio de Janeiro.xml',
        screenshot: {
          src: './assets/palettes/rio-de-janeiro/coreldraw-palette-screenshot-1.webp',
          description: 'Rio de Janeiro palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        file: './assets/palettes/rio-de-janeiro/Codigrate Rio de Janeiro.clr',
        fileName: 'Codigrate Rio de Janeiro.clr',
        screenshot: {
          src: './assets/palettes/rio-de-janeiro/macos-palette-screenshot-1.webp',
          description: 'Rio de Janeiro palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Morning Breeze', hex: '#F7FAF6' },
      { name: 'Lagoon Mist', hex: '#D0ECEF' },
      { name: 'Palm Shade', hex: '#D9EFD2' },
      { name: 'Garden Path', hex: '#B8E5AD' },
      { name: 'Jungle Canopy', hex: '#85B778' },
      { name: 'Emerald Palm', hex: '#13A166' },
      { name: 'Deep Jungle', hex: '#028134' },
      { name: 'Leaf Shadow', hex: '#2D7B18' },
      { name: 'Vivid Leaf', hex: '#47A731' },
      { name: 'Forest Ink', hex: '#1A510A' },
      { name: 'Rainforest', hex: '#375B2E' },
      { name: 'Tropical Water', hex: '#41AFBA' },
      { name: 'Atlantic Blue', hex: '#0A80B3' },
      { name: 'Bay Blue', hex: '#1065B8' },
      { name: 'Golden Samba', hex: '#A3860A' },
      { name: 'Ipanema Sun', hex: '#ECDA61' },
      { name: 'Guanabara Blue', hex: '#2287D5' },
      { name: 'Deep Guanabara', hex: '#137DD0' },
      { name: 'Carnival Green', hex: '#30A25E' },
      { name: 'Deep Carnival', hex: '#219D53' },
      { name: 'Carnival Gold', hex: '#E6C41A' },
      { name: 'Deep Gold', hex: '#E1BE0A' },
      { name: 'Sunset Red', hex: '#D15647' },
      { name: 'Deep Sunset', hex: '#DB3C29' },
    ],
  },
  {
    key: 'sydney',
    name: 'Sydney',
    category: 'cities',
    appearance: 'Light',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        screenshot: {
          src: './assets/palettes/sydney/figma-palette-screenshot-1.webp',
          description: 'Sydney palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        screenshot: {
          src: './assets/palettes/sydney/coreldraw-palette-screenshot-1.webp',
          description: 'Sydney palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        screenshot: {
          src: './assets/palettes/sydney/macos-palette-screenshot-1.webp',
          description: 'Sydney palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Sail White', hex: '#FFFFFF' },
      { name: 'Opera White', hex: '#F6F9FA' },
      { name: 'Harbour Mist', hex: '#CAE4EC' },
      { name: 'Bondi Shallows', hex: '#ABDAE8' },
      { name: 'Grey Gull', hex: '#96C1C7' },
      { name: 'Harbour Blue', hex: '#73B9D0' },
      { name: 'Reef Blue', hex: '#169DC5' },
      { name: 'Pacific Blue', hex: '#0F91C7' },
      { name: 'Tasman Teal', hex: '#0E5E76' },
      { name: 'Ocean Ink', hex: '#062E3A' },
      { name: 'Jade Bay', hex: '#2F9383' },
      { name: 'Peach Shell', hex: '#FAE5D9' },
      { name: 'Bondi Sand', hex: '#ECD268' },
      { name: 'Outback Gold', hex: '#AF8427' },
      { name: 'Desert Clay', hex: '#BA7347' },
      { name: 'Outback Copper', hex: '#D17F51' },
      { name: 'Summer Sky', hex: '#178BCA' },
      { name: 'Deep Summer', hex: '#0A82C3' },
      { name: 'Eucalyptus', hex: '#30A25E' },
      { name: 'Deep Eucalyptus', hex: '#219D53' },
      { name: 'Golden Wattle', hex: '#D6A840' },
      { name: 'Deep Wattle', hex: '#E0A621' },
      { name: 'Waratah Red', hex: '#C5564E' },
      { name: 'Deep Waratah', hex: '#CE3B31' },
    ],
  },
  {
    key: 'tallinn',
    name: 'Tallinn',
    category: 'cities',
    appearance: 'Light',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        file: './assets/palettes/tallinn/Codigrate Tallinn.tokens.json',
        fileName: 'Codigrate Tallinn.tokens.json',
        screenshot: {
          src: './assets/palettes/tallinn/figma-palette-screenshot-1.webp',
          description: 'Tallinn palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        file: './assets/palettes/tallinn/Codigrate Tallinn.xml',
        fileName: 'Codigrate Tallinn.xml',
        screenshot: {
          src: './assets/palettes/tallinn/coreldraw-palette-screenshot-1.webp',
          description: 'Tallinn palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        file: './assets/palettes/tallinn/Codigrate Tallinn.clr',
        fileName: 'Codigrate Tallinn.clr',
        screenshot: {
          src: './assets/palettes/tallinn/macos-palette-screenshot-1.webp',
          description: 'Tallinn palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Baltic Morning', hex: '#EDF2FA' },
      { name: 'Winter Sky', hex: '#D0DCEF' },
      { name: 'Limestone Blue', hex: '#A9B9DA' },
      { name: 'Pink Facade', hex: '#ECC2C2' },
      { name: 'Terracotta Roof', hex: '#C17777' },
      { name: 'Weathered Brick', hex: '#B1544B' },
      { name: 'Brick Lane', hex: '#B6564B' },
      { name: 'Amethyst', hex: '#81549C' },
      { name: 'Periwinkle', hex: '#7179CC' },
      { name: 'Cobalt Spire', hex: '#425EB8' },
      { name: 'Deep Cobalt', hex: '#184092' },
      { name: 'Old Town Indigo', hex: '#324979' },
      { name: 'Midnight Baltic', hex: '#0F244F' },
      { name: 'Harbor Blue', hex: '#377CC1' },
      { name: 'Courtyard Green', hex: '#548A64' },
      { name: 'Spruce Green', hex: '#1E7857' },
      { name: 'Nordic Sky', hex: '#397FB7' },
      { name: 'Deep Nordic', hex: '#2876B4' },
      { name: 'Linden Green', hex: '#30A25E' },
      { name: 'Deep Linden', hex: '#219D53' },
      { name: 'Amber Lantern', hex: '#C39A4E' },
      { name: 'Deep Amber', hex: '#CB9532' },
      { name: 'Rust Red', hex: '#C0564E' },
      { name: 'Deep Rust', hex: '#C63E34' },
    ],
  },
  {
    key: 'tokyo',
    name: 'Tokyo',
    category: 'cities',
    appearance: 'Dark',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        file: './assets/palettes/tokyo/Codigrate Tokyo.tokens.json',
        fileName: 'Codigrate Tokyo.tokens.json',
        screenshot: {
          src: './assets/palettes/tokyo/figma-palette-screenshot-1.webp',
          description: 'Tokyo palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        file: './assets/palettes/tokyo/Codigrate Tokyo.xml',
        fileName: 'Codigrate Tokyo.xml',
        screenshot: {
          src: './assets/palettes/tokyo/coreldraw-palette-screenshot-1.webp',
          description: 'Tokyo palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        file: './assets/palettes/tokyo/Codigrate Tokyo.clr',
        fileName: 'Codigrate Tokyo.clr',
        screenshot: {
          src: './assets/palettes/tokyo/macos-palette-screenshot-1.webp',
          description: 'Tokyo palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Night Alley', hex: '#0C0F1C' },
      { name: 'Tokyo Midnight', hex: '#1A1F35' },
      { name: 'Indigo District', hex: '#2A3051' },
      { name: 'Purple Alley', hex: '#542D58' },
      { name: 'Neon Purple', hex: '#8E2795' },
      { name: 'Neon Violet', hex: '#967AEA' },
      { name: 'Shibuya Blue', hex: '#7285DC' },
      { name: 'Metro Indigo', hex: '#7B89C8' },
      { name: 'Skyline Blue', hex: '#7FA0DD' },
      { name: 'Streetlight Silver', hex: '#AEB2C3' },
      { name: 'Cyan Sign', hex: '#5DC8D6' },
      { name: 'Matcha Neon', hex: '#5CC19D' },
      { name: 'Paper Lantern', hex: '#D3B690' },
      { name: 'Amber Sign', hex: '#DD9B7F' },
      { name: 'Pink Neon', hex: '#ECA1EB' },
      { name: 'Ultraviolet', hex: '#714CE3' },
      { name: 'Signal Blue', hex: '#4A93D0' },
      { name: 'Deep Signal', hex: '#2C8BD9' },
      { name: 'Jade Signal', hex: '#4FC093' },
      { name: 'Deep Jade', hex: '#34C68C' },
      { name: 'Amber Glow', hex: '#D0A24E' },
      { name: 'Deep Amber', hex: '#D99D30' },
      { name: 'Torii Red', hex: '#CF5A56' },
      { name: 'Deep Torii', hex: '#D83E39' },
    ],
  },
  {
    key: 'vienna',
    name: 'Vienna',
    category: 'cities',
    appearance: 'Dark',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        screenshot: {
          src: './assets/palettes/vienna/figma-palette-screenshot-1.webp',
          description: 'Vienna palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        screenshot: {
          src: './assets/palettes/vienna/coreldraw-palette-screenshot-1.webp',
          description: 'Vienna palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        screenshot: {
          src: './assets/palettes/vienna/macos-palette-screenshot-1.webp',
          description: 'Vienna palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Black Coffee', hex: '#0B0909' },
      { name: 'Mahogany Night', hex: '#2C1D1D' },
      { name: 'Opera Velvet', hex: '#4B2226' },
      { name: 'Crimson Parlor', hex: '#6A2F34' },
      { name: 'Muted Plum', hex: '#584143' },
      { name: 'Antique Rose', hex: '#806264' },
      { name: 'Bronze Shadow', hex: '#463921' },
      { name: 'Palace Olive', hex: '#98A67D' },
      { name: 'Garden Sage', hex: '#B6C39C' },
      { name: 'Pastry Cream', hex: '#F4D8B3' },
      { name: 'Marzipan', hex: '#ECC39A' },
      { name: 'Candlelight', hex: '#EACF8C' },
      { name: 'Gilded Frame', hex: '#C0A371' },
      { name: 'Vienna Rose', hex: '#D7999F' },
      { name: 'Porcelain', hex: '#E6D7D8' },
      { name: 'Imperial Gold', hex: '#DCA826' },
      { name: 'Danube Blue', hex: '#5A93C8' },
      { name: 'Deep Danube', hex: '#3D89D0' },
      { name: 'Ivy Green', hex: '#7DB075' },
      { name: 'Deep Ivy', hex: '#67B65B' },
      { name: 'Concert Gold', hex: '#D6A94A' },
      { name: 'Deep Concert', hex: '#D49A1E' },
      { name: 'Imperial Red', hex: '#D0605C' },
      { name: 'Deep Imperial', hex: '#D8453F' },
    ],
  },
  {
    key: 'london',
    name: 'London',
    category: 'cities',
    appearance: 'Dark',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        screenshot: {
          src: './assets/palettes/london/figma-palette-screenshot-1.webp',
          description: 'London palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        screenshot: {
          src: './assets/palettes/london/coreldraw-palette-screenshot-1.webp',
          description: 'London palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        screenshot: {
          src: './assets/palettes/london/macos-palette-screenshot-1.webp',
          description: 'London palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Coal Ink', hex: '#17161D' },
      { name: 'Dusk Slate', hex: '#201F29' },
      { name: 'Fog Indigo', hex: '#2D2B36' },
      { name: 'Portland Shadow', hex: '#3B3A45' },
      { name: 'Kerb Grey', hex: '#494757' },
      { name: 'Pavement Grey', hex: '#7C7A90' },
      { name: 'Drizzle Grey', hex: '#6B6F8A' },
      { name: 'Slate Blue', hex: '#8790AE' },
      { name: 'Fog Grey', hex: '#A9ADC2' },
      { name: 'Chalk Blue', hex: '#B9BFD8' },
      { name: 'Portland Stone', hex: '#DDDFEA' },
      { name: 'Brick Shadow', hex: '#422429' },
      { name: 'Clay Brick', hex: '#9A6B78' },
      { name: 'Pillar Crimson', hex: '#D42A44' },
      { name: 'Kiosk Red', hex: '#EE4B5B' },
      { name: 'Post Rose', hex: '#D06A73' },
      { name: 'Brick Rose', hex: '#E88790' },
      { name: 'Steel Blue', hex: '#5D89B0' },
      { name: 'Thames Steel', hex: '#7FA3C6' },
      { name: 'Mist Blue', hex: '#9BB6CE' },
      { name: 'Signal Red', hex: '#D93A3F' },
      { name: 'Lamp Amber', hex: '#D9A441' },
      { name: 'Beacon Blue', hex: '#5B9BD5' },
      { name: 'Park Green', hex: '#6FB98F' },
    ],
  },
  {
    key: 'dublin',
    name: 'Dublin',
    category: 'cities',
    appearance: 'Light',
    platforms: [
      {
        key: 'figma',
        name: 'Figma Palette',
        logo: './assets/third-parties/logo/figma-palette.webp',
        screenshot: {
          src: './assets/palettes/dublin/figma-palette-screenshot-1.webp',
          description: 'Dublin palette in Figma',
        },
      },
      {
        key: 'coreldraw',
        name: 'CorelDRAW Palette',
        logo: './assets/third-parties/logo/coreldraw-palette.webp',
        screenshot: {
          src: './assets/palettes/dublin/coreldraw-palette-screenshot-1.webp',
          description: 'Dublin palette in CorelDRAW',
        },
      },
      {
        key: 'macos',
        name: 'MacOS Color Palette',
        logo: './assets/third-parties/logo/macos-color-palette.webp',
        screenshot: {
          src: './assets/palettes/dublin/macos-palette-screenshot-1.webp',
          description: 'Dublin palette in the MacOS color picker',
        },
      },
    ],
    colors: [
      { name: 'Ha\'penny White', hex: '#F1F9F3' },
      { name: 'Liffey Mist', hex: '#D3F3DB' },
      { name: 'Lawn Mist', hex: '#AAE4B8' },
      { name: 'Morning Sky', hex: '#A0E3B1' },
      { name: 'Castle Sky', hex: '#6CC682' },
      { name: 'Tricolour Green', hex: '#169B62' },
      { name: 'Shamrock Green', hex: '#1F9140' },
      { name: 'Maple Glow', hex: '#F08C2E' },
      { name: 'Stephen\'s Green', hex: '#1B6B3A' },
      { name: 'Tower Shade', hex: '#3B564C' },
      { name: 'Black Pool', hex: '#0F2E1A' },
      { name: 'Autumn Blaze', hex: '#E26B03' },
      { name: 'Tricolour Orange', hex: '#CF6106' },
      { name: 'Autumn Haze', hex: '#BD7135' },
      { name: 'Copper Leaf', hex: '#A34C08' },
      { name: 'Path Gold', hex: '#FACA73' },
      { name: 'Milky Coffee', hex: '#A38063' },
      { name: 'Turf Haze', hex: '#8A6A4B' },
      { name: 'Hedge Bark', hex: '#654E1A' },
      { name: 'Warm Stone', hex: '#7D7166' },
      { name: 'Dublin Sky', hex: '#2F86C8' },
      { name: 'Kelly Green', hex: '#4CBB17' },
      { name: 'Harvest Gold', hex: '#D6A03A' },
      { name: 'Temple Bar Red', hex: '#C5453E' },
    ],
  },
];

/** Palettes whose app screenshots are not captured yet (assets/palettes/<key>/ has none): left out of the
 *  palettes page and the home's palettes box until they are (owner 2026-10-15: never shown, not even greyed
 *  out). Drop a key once its pictures land. */
export const PALETTES_AWAITING_SCREENSHOTS = new Set( [ 'fuji', 'london', 'dublin' ] );

/** Whether a palette is listed (it exists and its app pictures are in). */
export function isPaletteShown( key: string | undefined ): boolean {
  return !!key && !PALETTES_AWAITING_SCREENSHOTS.has( key ) && THEME_PALETTES.some( p => p.key === key );
}
